<div class="wrapper flex flex-col justify-between">
  <div class="heading-row flex justify-between items-center mb-[40px]">
    <div class="heading text-type-2">
      {{ data?.id ? data?.rfi_no : 'Create' }}
    </div>
    @if (data?.id) {
      <div class="rfi-more-menu-container">
        @if (downloadingReport) {
          <mat-spinner
            color="primary"
            diameter="24"
            mode="indeterminate"
            strokeWidth="3"
            data-testid="rfi-download-spinner"
            ></mat-spinner>
        } @else {
          <button
            mat-icon-button
            [matMenuTriggerFor]="rfiDetailMoreMenu"
            class="rfi-more-menu-button"
            data-testid="rfi-detail-more-menu"
            [matTooltip]="'More actions'"
            matTooltipClass="project-name-tooltip"
          >
            <mat-icon>more_horiz</mat-icon>
          </button>
        }
      </div>
      <mat-menu #rfiDetailMoreMenu="matMenu">
        @if (canDeleteRfi) {
          <button mat-menu-item data-testid="rfi-delete-draft"
            [disabled]="deletingRfi" (click)="deleteRfi()">
            <mat-icon svgIcon="trash"></mat-icon>
            <span>Delete</span>
          </button>
        }
        <button
          mat-menu-item
          data-testid="rfi-download-pdf"
          (click)="downloadRfiDetail(false)"
        >
          <mat-icon>download</mat-icon>
          <span>Download PDF</span>
        </button>
        <button
          mat-menu-item
          data-testid="rfi-download-pdf-with-discussions"
          (click)="downloadRfiDetail(true)"
        >
          <mat-icon>forum</mat-icon>
          <span>Download PDF with discussions</span>
        </button>
      </mat-menu>
    }
  </div>
  @if (!data?.id) {
    <div class="details flex-1">
      <app-view-field
        [value]="form?.controls['rfiNo']?.value"
        class="w-full mb-[30px] adjust-label"
        label="Rfi No"
        />
      <app-text-input
        (checkForErrors)="checkForErrors($event)"
        [error]="errorMessages['title']"
        [parentFormGroup]="form"
        class="w-full mb-[20px]"
        controlName="title"
        label="title"
        />
      <app-text-area
        (checkForErrors)="checkForErrors($event)"
        [error]="errorMessages['description']"
        [parentFormGroup]="form"
        class="w-full mb-[20px]"
        controlName="description"
        label="description"
        />
      <app-date-picker
        (checkForErrors)="checkForErrors($event)"
        [error]="errorMessages['need_by_date']"
        [parentFormGroup]="form"
        class="w-full mb-[20px]"
        controlName="need_by_date"
        label="need by date"
        />
      <app-dropdown
        (checkForErrors)="checkForErrors($event)"
        [enableMultiple]="true"
        [enableSearch]="true"
        [error]="errorMessages['reviewers']"
        [options]="userOptions"
        [parentFormGroup]="form"
        [selectionString]="form.controls['reviewers']?.value?.length > 1 ? 'Reviewers' : 'Reviewer'"
        [showCount]="true"
        class="w-full mb-[20px]"
        controlName="reviewers"
        label="reviewers"
        />
      @if (role === 'project-manager') {
        <app-dropdown
          (checkForErrors)="checkForErrors($event)"
          [enableMultiple]="true"
          [enableSearch]="true"
          [error]="errorMessages['cc_users']"
          [options]="userOptions"
          [parentFormGroup]="form"
          [selectionString]="form.controls['cc_users']?.value?.length > 1 ? 'Users' : 'User'"
          [showCount]="true"
          class="w-full mb-[20px]"
          controlName="cc_users"
          label="cc users"
          />
      }
      @if (hasLocation) {
        <app-location-station-card
          (onDelete)="deleteLocation()"
          [isEditable]="locationEditable"
          [latitude]="form.controls['latitude']?.value"
          [longitude]="form.controls['longitude']?.value"
          [locationText]="form.controls['location']?.value"
          [stationRange]="form.controls['station_range']?.value"
          [form]="form"
          [recordLabel]="'RFI'"
          class="location-section w-full mb-[20px] mt-[10px]"
          data-testid="rfi-location-card"
          />
      }
      @if (mediaFiles?.length) {
        <app-pictures-section-with-tags
          (onDelete)="deletePicture($event)"
          [isEditable]="form.status !== 'DISABLED'"
          [pictures]="mediaFiles"
          class="pictures-section mb-[40px] mt-[30px]"
          label="attachments:"
          />
      }
    </div>
    <div class="action-section mb-[5px] flex flex-row gap-[20px] w-full">
      <div [matMenuTriggerFor]="add" class="action-button add-button">
        <mat-icon class="add" svgIcon="plus"></mat-icon>
      </div>
      <app-secondary-button (handleClick)="save()" [isDisabled]="!isFormDirty" class="flex-1">Save
      </app-secondary-button>
      <app-primary-button (handleClick)="submit()" [isDisabled]="!isFormDirty" class="flex-1">Submit
      </app-primary-button>
    </div>
  } @else {
    <mat-tab-group
      #snTabGroup
      (selectedTabChange)="onTabChange($event)"
      [selectedIndex]="selectedTabIndex"
      class="contents-tab-group flex-1"
      >
      <mat-tab label="Details">
        <div
          class="details scrollbar-hide h-full flex-1 pt-[40px] w-full flex flex-col overflow-x-hidden justify-between">
          @if (creatorRole) {
            <div class="form-section">
              <app-view-field
                [value]="form?.controls['rfiNo']?.value"
                class="w-full mb-[30px] adjust-label"
                label="Rfi No"
                />
              @if (data?.createdBy) {
                <div class="row-details flex flex-col gap-[12px] mb-[30px]">
                  <div class="label w-full uppercase">
                    Created By:
                  </div>
                  <div class="value w-full text-type-11">
                    <div class="user flex flex-row gap-[8px]">
                      <div class="user-avatar">
                        {{ data?.createdBy?.first_name?.charAt(0) }}
                      </div>
                      <div class="user-details flex flex-col">
                        <div class="user-name">
                          {{ data?.createdBy?.first_name }} {{ data?.createdBy?.last_name }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }
              <app-text-input
                (checkForErrors)="checkForErrors($event)"
                [error]="errorMessages['title']"
                [parentFormGroup]="form"
                class="w-full mb-[20px]"
                controlName="title"
                label="title"
                />
              <app-text-area
                (checkForErrors)="checkForErrors($event)"
                [error]="errorMessages['description']"
                [parentFormGroup]="form"
                class="w-full mb-[20px]"
                controlName="description"
                label="description"
                />
              <app-date-picker
                (checkForErrors)="checkForErrors($event)"
                [error]="errorMessages['need_by_date']"
                [parentFormGroup]="form"
                class="w-full mb-[20px]"
                controlName="need_by_date"
                label="need by date"
                />
              <app-dropdown
                (checkForErrors)="checkForErrors($event)"
                [enableMultiple]="true"
                [enableSearch]="true"
                [error]="errorMessages['reviewers']"
                [options]="userOptions"
                [parentFormGroup]="form"
                [selectionString]="form.controls['reviewers']?.value?.length > 1 ? 'Reviewers' : 'Reviewer'"
                [showCount]="true"
                class="w-full mb-[20px]"
                controlName="reviewers"
                label="reviewers"
                />
              @if (hasLocation) {
                <app-location-station-card
                  (onDelete)="deleteLocation()"
                  [isEditable]="locationEditable"
                  [latitude]="form.controls['latitude']?.value"
                  [longitude]="form.controls['longitude']?.value"
                  [locationText]="form.controls['location']?.value"
                  [stationRange]="form.controls['station_range']?.value"
                  [form]="form"
                  [recordLabel]="'RFI'"
                  class="location-section w-full mb-[20px] mt-[10px]"
                  data-testid="rfi-location-card"
                  />
              }
              @if (mediaFiles?.length) {
                <app-pictures-section-with-tags
                  (onDelete)="deletePicture($event)"
                  [isEditable]="data?.status !== 'closed' && data?.status !== 'submitted' && data?.status !== 'sent_for_review'"
                  [pictures]="mediaFiles"
                  class="pictures-section mb-[40px] mt-[30px]"
                  label="attachments:"
                  />
              }
              @if (displayAprovalNextActions || data.status ==='closed') {
                <hr class="hr-line" />
              }
              @if (actionsOptions?.length && displayAprovalNextActions) {
                <app-dropdown
                  (checkForErrors)="checkForErrors($event)"
                  [error]="errorMessages['actions']"
                  [options]="actionsOptions"
                  [parentFormGroup]="form"
                  [placeholder]="'Take action on this rfi'"
                  class="w-full mb-[20px]"
                  controlName="actions"
                  label="Actions"
                  />
              }
              @if (form.controls?.['actions_select_from_previous_responses'] && responseList?.length) {
                <div
                  class="flex flex-row justify-between items-center mb-[30px] gap-[20px] w-full">
                  <div class="label text-type-13 ">
                    Select from previous responses:
                  </div>
                  <mat-slide-toggle
                    (change)="onToggle($event)"
                    [checked]="form.controls['actions_select_from_previous_responses'].value"
                    [disableRipple]="false"
                    class="slide-toggle-btn"
                    color="primary"
                    />
                </div>
              }
              @if (form?.controls?.['actions_response_dropdown']) {
                <app-dropdown
                  (checkForErrors)="checkForErrors($event)"
                  [error]="errorMessages['actions_response_dropdown']"
                  [options]="responseList"
                  [parentFormGroup]="form"
                  class="w-full mb-[20px]"
                  controlName="actions_response_dropdown"
                  label="Select response from"
                  />
              }
              @if (form?.controls?.['actions__reviewers']) {
                <app-dropdown
                  (checkForErrors)="checkForErrors($event)"
                  [enableMultiple]="true"
                  [enableSearch]="true"
                  [error]="errorMessages['actions__reviewers']"
                  [options]="userOptions"
                  [parentFormGroup]="form"
                  [selectionString]="form.controls['actions__reviewers']?.value?.length > 1 ? 'Reviewers' : 'Reviewer'"
                  [showCount]="true"
                  class="w-full mb-[20px]"
                  controlName="actions__reviewers"
                  label="reviewers"
                  />
              }
              @if (form?.controls?.['actions__fyi_users']) {
                <app-dropdown
                  (checkForErrors)="checkForErrors($event)"
                  [enableMultiple]="true"
                  [enableSearch]="true"
                  [error]="errorMessages['actions__fyi_users']"
                  [options]="userOptions"
                  [parentFormGroup]="form"
                  [selectionString]="form.controls['actions__fyi_users']?.value?.length > 1 ? 'Users' : 'User'"
                  [showCount]="true"
                  class="w-full mb-[20px]"
                  controlName="actions__fyi_users"
                  label="Fyi users"
                  />
              }
              <app-text-area
                (checkForErrors)="checkForErrors($event)"
                [error]="errorMessages['actions_comments']"
                [parentFormGroup]="form"
                class="w-full mb-[20px]"
                controlName="actions_comments"
                label="Comments"
                />
              <app-text-area
                (checkForErrors)="checkForErrors($event)"
                [error]="errorMessages['actions_final_response']"
                [parentFormGroup]="form"
                class="w-full mb-[20px]"
                controlName="actions_final_response"
                label="final response"
                />
              @if (form?.controls?.['actions_attachments']) {
                <app-pictures-section-with-tags
                  (onDelete)="deleteActionPicture($event)"
                  [add]="true"
                  [pictures]="mediaFiles"
                  [tags]="'actions-attachments'"
                  class="pictures-section mb-[40px]"
                  label="Attachments"
                  />
              }
              @if (data.status ==='closed') {
                <div class="row-details flex flex-col gap-[12px] mb-[40px]">
                  <div class="label w-full uppercase">
                    Final response:
                  </div>
                  <div class="value w-full text-type-11">
                    {{ data?.final_response }}
                  </div>
                  <app-pictures-section-with-tags
                    (onDelete)="deletePicture($event)"
                    [isEditable]="false"
                    [pictures]="mediaFiles"
                    [tags]="'actions-attachments'"
                    class="pictures-section mb-[40px] mt-[30px]"
                    label="final response attachment"
                    />
                </div>
              }
            </div>
            <div
              [ngClass]="{'mt-[40px]' : creatorRole}"
              class="action-section mb-[5px] w-full flex justify-between items-center gap-[10px]"
              >
              <div
                [class.disabled]="data.status !== 'draft'"
                [matMenuTriggerFor]="add"
               
                class="action-button add-button w-[15%] ml-[5px]">
                <mat-icon class="add" svgIcon="plus"></mat-icon>
              </div>
              <div class="buttons-div w-[85%] flex justify-between items-center gap-[10px]">
                @if (creatorRole && !displayAprovalNextActions) {
                  <app-secondary-button
                    (handleClick)="save()"
                    [isDisabled]="!isFormDirty"
                    [ngClass]="{'w-1/2': displayNextActions === true, 'flex-1': displayNextActions === false || role !== 'contractor'}"
                    >
                    Save
                  </app-secondary-button>
                }
                @if (displayAprovalNextActions) {
                  <app-primary-button
                    (handleClick)="execute()"
                    [isDisabled]="!selectedAction?.length"
                    class="flex-1"
                    >
                    Submit
                  </app-primary-button>
                }
                @if (displayNextActions) {
                  <div
                    [ngClass]="{'w-1/2': displayNextActions === true, 'flex-1': displayNextActions === false || role !== 'contractor'}">
                    @for (na of data?.['next-actions']; track na) {
                      @if (na?.actions?.length) {
                        <div>
                          @for (action of na?.['actions']; track action) {
                            <div
                              class="next-actions-section w-full flex flex-row-reverse gap-[20px]">
                              @if (action?.options?.styles?.color === 'primary') {
                                <app-primary-button
                                  (handleClick)="executeState(action)"
                                  [color]="action?.options?.styles?.color"
                                  class="action-btn flex-1"
                                  >
                                  {{ action?.options?.label }}
                                </app-primary-button>
                              }
                              @if (action?.options?.styles?.color === 'accent' || action?.options?.styles?.color === 'warn') {
                                <app-secondary-button
                                  (handleClick)="executeState(action)"
                                  class="action-btn flex-1"
                                  >
                                  {{ action?.options?.label }}
                                </app-secondary-button>
                              }
                            </div>
                          }
                        </div>
                      }
                    }
                  </div>
                }
              </div>
            </div>
          } @else {
            <div class="details">
              <div class="row-details flex flex-col gap-[12px] mb-[40px]">
                <div class="label w-full uppercase">
                  Status: {{ data?.status }}
                </div>
                <div class="value w-full text-type-11">
                  <div
                    [ngClass]="data?.status && statusMap[data?.status] ? [statusMap[data.status].bgColor, statusMap[data.status].textColor] : []"
                    class="status-chip px-[14px] rounded-full">
                    @if (role === 'project-manager') {
                      @if (data?.status === 'submitted') {
                        Open
                      } @else {
                        {{ statusMap[data?.status]?.label }}
                      }
                    }
                    @if (role === 'contractor' || role?.includes('contractor') || role === 'reviewer') {
                      @if (data?.status === 'submitted' || data?.status === 'sent_for_review') {
                        Open
                      } @else {
                        {{ statusMap[data?.status]?.label }}
                      }
                    }
                  </div>
                </div>
              </div>
              <div class="row-details flex flex-col gap-[12px] mb-[40px]">
                <div class="label w-full uppercase">
                  RFI No:
                </div>
                <div class="value w-full text-type-11">
                  {{ data?.rfi_no }}
                </div>
              </div>
              @if (data?.createdBy) {
                <div class="row-details flex flex-col gap-[12px] mb-[40px]">
                  <div class="label w-full uppercase">
                    Created By:
                  </div>
                  <div class="value w-full text-type-11">
                    <div class="user flex flex-row gap-[8px]">
                      <div class="user-avatar">
                        {{ data?.createdBy?.first_name?.charAt(0) }}
                      </div>
                      <div class="user-details flex flex-col">
                        <div class="user-name">
                          {{ data?.createdBy?.first_name }} {{ data?.createdBy?.last_name }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }
              @if (data?.cc_users?.length) {
                <div class="row-details flex flex-col gap-[12px] mb-[40px]">
                  <div class="label w-full uppercase">
                    CC Users:
                  </div>
                  <div class="value w-full text-type-11">
                    @for (user of data.cc_users; track user) {
                      <div class="details mt-[20px]">
                        <div class="user flex flex-row gap-[8px]">
                          <div class="user-avatar">
                            {{ user?.first_name?.charAt(0) }}
                          </div>
                          <div class="user-details flex flex-col">
                            <div class="user-name">
                              {{ user?.email }}
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              }
              @if (data?.reviewers?.length) {
                <div class="row-details flex flex-col gap-[12px] mb-[40px]">
                  <div class="label w-full uppercase">
                    Reviewers:
                  </div>
                  <div class="value w-full text-type-11">
                    @for (user of data.reviewers; track user) {
                      <div class="details mt-[20px]">
                        <div class="user flex flex-row gap-[8px]">
                          <div class="user-avatar">
                            {{ user?.first_name?.charAt(0) }}
                          </div>
                          <div class="user-details flex flex-col">
                            <div class="user-name">
                              {{ user?.email }}
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              }
              <div class="row-details flex flex-col gap-[12px] mb-[40px]">
                <div class="label w-full uppercase">
                  Description:
                </div>
                <div class="value w-full text-type-11">
                  {{ data?.description || 'N/A' }}
                </div>
              </div>
              @if (hasLocation) {
                <app-location-station-card
                  [isEditable]="false"
                  [latitude]="form.controls['latitude']?.value"
                  [longitude]="form.controls['longitude']?.value"
                  [locationText]="form.controls['location']?.value"
                  [stationRange]="form.controls['station_range']?.value"
                  [form]="form"
                  class="location-section w-full mb-[20px] mt-[10px]"
                  data-testid="rfi-location-card-readonly"
                  />
              }
              @if (mediaFiles?.length && this.getPictures()?.length) {
                <app-pictures-section-with-tags
                  (onDelete)="deletePicture($event)"
                  [isEditable]="data?.status !== 'closed' && data?.status !== 'submitted' && data?.status !== 'sent_for_review'"
                  [pictures]="mediaFiles"
                  class="pictures-section mb-[40px] mt-[30px]"
                  label="attachments:"
                  />
              }
              @if (displayAprovalNextActions || data.status ==='closed') {
                <hr class="hr-line" />
              }
              @if (actionsOptions?.length && displayNextActions) {
                <app-dropdown
                  (checkForErrors)="checkForErrors($event)"
                  [error]="errorMessages['actions']"
                  [options]="actionsOptions"
                  [parentFormGroup]="form"
                  [placeholder]="'Take action on this rfi'"
                  class="w-full mb-[20px]"
                  controlName="actions"
                  label="Actions"
                  />
              }
              @if (form.controls?.['actions_select_from_previous_responses'] && responseList?.length) {
                <div
                  class="flex flex-row justify-between items-center mb-[30px] gap-[20px] w-full">
                  <div class="label text-type-13 ">
                    Select from previous responses:
                  </div>
                  <mat-slide-toggle
                    (change)="onToggle($event)"
                    [checked]="form.controls['actions_select_from_previous_responses'].value"
                    [disableRipple]="false"
                    class="slide-toggle-btn"
                    color="primary"
                    />
                </div>
              }
              @if (form?.controls?.['actions_response_dropdown']) {
                <app-dropdown
                  (checkForErrors)="checkForErrors($event)"
                  [error]="errorMessages['actions_response_dropdown']"
                  [options]="responseList"
                  [parentFormGroup]="form"
                  class="w-full mb-[20px]"
                  controlName="actions_response_dropdown"
                  label="Select response from"
                  />
              }
              @if (form?.controls?.['actions__reviewers']) {
                <app-dropdown
                  (checkForErrors)="checkForErrors($event)"
                  [enableMultiple]="true"
                  [enableSearch]="true"
                  [error]="errorMessages['actions__reviewers']"
                  [options]="userOptions"
                  [parentFormGroup]="form"
                  [selectionString]="form.controls['actions__reviewers']?.value?.length > 1 ? 'Reviewers' : 'Reviewer'"
                  [showCount]="true"
                  class="w-full mb-[20px]"
                  controlName="actions__reviewers"
                  label="reviewers"
                  />
              }
              @if (form?.controls?.['actions__fyi_users']) {
                <app-dropdown
                  (checkForErrors)="checkForErrors($event)"
                  [enableMultiple]="true"
                  [enableSearch]="true"
                  [error]="errorMessages['actions__fyi_users']"
                  [options]="userOptions"
                  [parentFormGroup]="form"
                  [selectionString]="form.controls['actions__fyi_users']?.value?.length > 1 ? 'Users' : 'User'"
                  [showCount]="true"
                  class="w-full mb-[20px]"
                  controlName="actions__fyi_users"
                  label="Fyi users"
                  />
              }
              <app-text-area
                (checkForErrors)="checkForErrors($event)"
                [error]="errorMessages['actions_comments']"
                [parentFormGroup]="form"
                class="w-full mb-[20px]"
                controlName="actions_comments"
                label="Comments"
                />
              <app-text-area
                (checkForErrors)="checkForErrors($event)"
                [error]="errorMessages['actions_final_response']"
                [parentFormGroup]="form"
                class="w-full mb-[20px]"
                controlName="actions_final_response"
                label="final response"
                />
              @if (form?.controls?.['actions_attachments']) {
                <app-pictures-section-with-tags
                  (onDelete)="deleteActionPicture($event)"
                  [add]="true"
                  [pictures]="mediaFiles"
                  [tags]="'actions-attachments'"
                  class="pictures-section mb-[40px]"
                  label="Attachments"
                  />
              }
              @if (data.status ==='closed') {
                <div class="row-details flex flex-col gap-[12px] mb-[40px]">
                  <div class="label w-full uppercase">
                    Final response:
                  </div>
                  <div class="value w-full text-type-11">
                    {{ data?.final_response }}
                  </div>
                  <app-pictures-section-with-tags
                    (onDelete)="deletePicture($event)"
                    [isEditable]="false"
                    [pictures]="finalResponse[0]?.attachments"
                    [tags]="'actions-attachments'"
                    class="pictures-section mb-[40px] mt-[30px]"
                    label="final response attachment"
                    />
                </div>
              }
            </div>
            <div class="action-section mb-[5px] w-full flex justify-between items-center gap-[10px]"
              >
              <app-primary-button
                (handleClick)="execute()"
                [isDisabled]="!selectedAction?.length"
                class="flex-1"
                >
                Submit
              </app-primary-button>
            </div>
          }
        </div>
      </mat-tab>
      <mat-tab label="Discussion">
        <app-rfis-workflow [data]=data />
      </mat-tab>
    </mat-tab-group>
  }
</div>

<input
  #fileInput
  (change)="onFileSelected($event)"
  class="hidden"
  multiple="multiple"
  type="file" />
<mat-menu #add="matMenu">
  @for (option of addMenuOptions; track option) {
    <button
      (click)="option.handler()"
      [attr.data-testid]="'rfi-add-' + option.key"
      mat-menu-item
      >
      <div class="add-menu-item flex justify-start items-center">
        <div class="flex justify-center items-center h-[48px]">
          <mat-icon [svgIcon]="option.icon" class="menu-icon" />
        </div>
        <div class="menu-label">{{ option.label }}</div>
      </div>
    </button>
  }
</mat-menu>
